/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 最新プレスリリース一覧を取得するAPIのリクエスト
 * @export
 * @interface SearchLatestPressReleasesByBusinessCategoryLv2IdRequest
 */
export interface SearchLatestPressReleasesByBusinessCategoryLv2IdRequest {
    /**
     * ビジネスカテゴリlv1のIDリスト
     * @type {Array<string>}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdRequest
     */
    busiCateLv1Ids?: Array<string>;
    /**
     * 企業カテゴリのIDリスト
     * @type {Array<string>}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdRequest
     */
    companyCateIds?: Array<string>;
    /**
     * エリアのIDリスト
     * @type {Array<number>}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdRequest
     */
    regionIds?: Array<number>;
    /**
     * 取得開始日時。フォーマット：'Y-m-d H:i:s'
     * @type {string}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdRequest
     */
    startDate?: string;
    /**
     * 取得終了日時。フォーマット：'Y-m-d H:i:s'
     * @type {string}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdRequest
     */
    endDate?: string;
    /**
     * 次のデータを取得する開始点となる識別子. {unix_timestamp}_{identifier}という形式
     * @type {string}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdRequest
     */
    cursor?: string;
    /**
     * 取得するプレスリリース数
     * @type {number}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdRequest
     */
    limit?: number;
}

export function SearchLatestPressReleasesByBusinessCategoryLv2IdRequestFromJSON(json: any): SearchLatestPressReleasesByBusinessCategoryLv2IdRequest {
    return SearchLatestPressReleasesByBusinessCategoryLv2IdRequestFromJSONTyped(json, false);
}

export function SearchLatestPressReleasesByBusinessCategoryLv2IdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchLatestPressReleasesByBusinessCategoryLv2IdRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'busiCateLv1Ids': !exists(json, 'busi_cate_lv1_ids') ? undefined : json['busi_cate_lv1_ids'],
        'companyCateIds': !exists(json, 'company_cate_ids') ? undefined : json['company_cate_ids'],
        'regionIds': !exists(json, 'region_ids') ? undefined : json['region_ids'],
        'startDate': !exists(json, 'start_date') ? undefined : json['start_date'],
        'endDate': !exists(json, 'end_date') ? undefined : json['end_date'],
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SearchLatestPressReleasesByBusinessCategoryLv2IdRequestToJSON(value?: SearchLatestPressReleasesByBusinessCategoryLv2IdRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'busi_cate_lv1_ids': value.busiCateLv1Ids,
        'company_cate_ids': value.companyCateIds,
        'region_ids': value.regionIds,
        'start_date': value.startDate,
        'end_date': value.endDate,
        'cursor': value.cursor,
        'limit': value.limit,
    };
}

